/** 排期与预算-表单配置 */
export {
  delivery_setting,
};

const delivery_setting = {
  value: {},
  children: {
    schedule_type: {
      label: '投放时间类型',
      type: 'radio-group',
      isButton: true,
      formItemProps: {
        required: true,
      },
      options: [
        {
          label: '从今天起长期投放',
          value: 'SCHEDULE_FROM_NOW',
        },
        {
          label: '设置开始和结束日期',
          value: 'SCHEDULE_START_END',
        },
      ],
      value: 'SCHEDULE_FROM_NOW',
    },
    /**
     * 投放起始时间，当schedule_type = SCHEDULE_START_END时必填
     * 如：2017-01-01 精确到天，广告投放起始时间不允许修改
     */
    start_time: {
      label: '投放时间',
      type: 'date-picker',
      hidden: true,
      value: [],
      props: {
        'type': 'daterange',
        'range-separator': '至',
        'start-placeholder': '开始日期',
        'end-placeholder': '结束日期',
        'value-format': 'yyyy-MM-dd',
      },
      rules: [{ required: true, message: '请选择投放时间', trigger: 'change' }],
    },
    schedule_time: {
      label: '投放时间段',
      hidden: true,
      value: new Array(336).fill(1).join(''),
    },
    bid_type: {
      label: '竞价策略',
      type: 'radio-group',
      isButton: true,
      formItemProps: {
        required: true,
      },
      options: [
        {
          label: '稳定成本',
          value: 'CUSTOM',
        },
        {
          label: '最大转化投放',
          value: 'NO_BID',
        },
      ],
      value: 'CUSTOM',
    },
    budget_mode: {
      label: '项目预算',
      type: 'radio-group',
      isButton: true,
      options: [
        {
          label: '不限',
          value: 'BUDGET_MODE_INFINITE',
        },
        {
          label: '日预算',
          value: 'BUDGET_MODE_DAY',
        },
      ],
      formItemProps: {
        required: true,
      },
      value: 'BUDGET_MODE_INFINITE',
      disabled: false,
    },
    budget_optimize_switch: {
      label: '预算择优分配',
      type: 'radio-group',
      isButton: true,
      hidden: true,
      options: [
        {
          label: '不开启',
          value: 'OFF',
        },
        {
          label: '开启',
          value: 'ON',
        },
      ],
      formItemProps: {
        required: true,
      },
      value: 'OFF',
      disabled: false,
    },
    /**
     * budget_mode = BUDGET_MODE_DAY时有效且必填
     * 项目预算，取值范围: ≥ 300
     */
    budget: {
      label: '日预算',
      type: 'input-number',
      hidden: true,
      value: '',
      formItemProps: {
        required: true,
      },
      props: {
        min: 300,
      },
    },
    /** 目标转化出价/预期成本， 取值范围：0.01-10000元。当 bid_type = NO_BID 时，不支持该字段；当delivery_mode = PROCEDURAL && landing_type = APP/MICRO_GAME/LINK 时必填；当 delivery_mode = MANUAL &&项目成本稳投开启&& pricing=OCPC/OCPM 时必填 */
    cpa_bid: {
      label: '出价',
      type: 'input-number',
      hidden: true,
      value: '',
      formItemProps: {
        required: true,
      },
      props: {
        min: 0.01,
        max: 10000,
      },
    },
    deep_bid_type: {
      label: '深度优化方式',
      type: 'radio-group',
      isButton: true,
      hidden: true,
      options: [],
      value: '',
      formItemProps: {
        required: true,
      },
      props: {
        min: 300,
        disabled: false,
      },
      rules: [{ required: true, message: '请选择深度优化方式', trigger: 'change' }],
      is_loading: false,
    },
    /** 深度优化出价，deep_bid_type = DEEP_BID_MIN 时必填。取值范围：0.1~10000元 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错 */
    deep_cpabid: {
      label: '深度优化出价',
      type: 'input-number',
      hidden: true,
      value: '',
      formItemProps: {
        required: true,
      },
      props: {
        min: 0.1,
        max: 10000,
      },
    },
    /** 深度转化ROI系数, 范围(0,5]，精度：保留小数点后四位，当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME时 &&深度优化目标为付费ROI（AD_CONVERT_TYPE_PURCHASE_ROI）时必填，当delivery_mode =MANUAL时填写报错 */
    roi_goal: {
      label: '深度转化ROI系数',
      type: 'input-number',
      hidden: true,
      value: 0.1,
      formItemProps: {
        required: true,
      },
      props: {
        min: 0,
      },
    },
  },
};
